// Copyright (c) 2018 Deere & Company

import OpenPipPrograms from '@deere/cps-it.warranty-model-factory/lib/open-pip-programs';
import t from 'tcomb';

const Report = t.list(OpenPipPrograms, 'Report');

export const getDefaultState = () => new Report([]);

export default Report;



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/state/report.js